// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3ygAN","messages":"Chat_messages__aBGas","dateDivider":"Chat_dateDivider__3HXiw"};